import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { needs } from '../data/needs';
import { OrigenChip } from './origen/OrigenChip';
import { waLink } from '../utils/whatsapp';
export function NeedSelector() {
  return <section id="necesidad" className="bg-[#F0F7F7] py-12 lg:py-20" aria-labelledby="necesidad-title" data-id="element-184" data-mp="1b26qid5dhwxo">
      <div className="mx-auto max-w-[900px] px-5" data-id="element-185" data-mp="1fynglcw4ulde">
        <header className="text-center" data-id="element-186" data-mp="j9pm7vsaopgr">
          <h2 id="necesidad-title" className="font-display text-[26px] font-bold text-ink lg:text-[36px]" data-id="element-187" data-mp="jb0xshrzf1if">
            ¿Qué te trajo aquí hoy?
          </h2>
          <p className="mx-auto mt-4 max-w-[560px] font-sans text-[17px] leading-[1.6] text-muted" data-id="element-188" data-mp="sanoo9n34ox8">
            Cuéntanos lo que necesitas y te orientamos por WhatsApp antes de tu visita.
          </p>
          <OrigenChip layout="flow" order={2} data-id="element-189" data-mp="23pt48e8behy9">
            Convierte intención vaga en acción concreta. El paciente no necesita saber qué tratamiento quiere, solo
            identificar su problema. Eso elimina la barrera más común para no agendar.
          </OrigenChip>
        </header>

        <ul className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-190" data-mp="114z5mijqcdc1">
          {needs.map(need => {
          const Icon = need.icon;
          const dashed = need.variant === 'dashed';
          return <li key={need.id} data-id="element-191" data-mp="r7kp6ixt3ojq">
                <a href={waLink(need.message)} target="_blank" rel="noreferrer" className={`group flex h-full flex-col rounded-2xl p-6 shadow-soft transition-all duration-200 hover:-translate-y-[2px] hover:border-secondary hover:shadow-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2 ${dashed ? 'border-[1.5px] border-dashed border-hairline bg-ivory' : 'border-[1.5px] border-hairline bg-white'}`} data-id="element-192" data-mp="r6jfahsj183l">
                  <span className="flex h-[52px] w-[52px] items-center justify-center rounded-xl bg-mist" data-id="element-193" data-mp="3kzw262qbabfy">
                    <Icon className="h-8 w-8 text-secondary" strokeWidth={1.5} data-id="element-194" data-mp="3pypgtyhc48hp" />
                  </span>
                  <h3 className="mt-4 font-sans text-[16px] font-semibold text-ink" data-id="element-195" data-mp="3bzpp2hyizdhb">{need.title}</h3>
                  <p className="mt-1 font-sans text-[13px] leading-[1.6] text-muted" data-id="element-196" data-mp="3g09mznqxal4i">{need.description}</p>
                  <span className="mt-4 inline-flex items-center gap-1 font-sans text-[12px] font-medium text-whatsapp opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-focus-visible:opacity-100" data-id="element-197" data-mp="7kpvat5whark">
                    Escribir por WhatsApp
                    <ArrowRightIcon className="h-3 w-3" data-id="element-198" data-mp="3uw91bg4mlhi3" />
                  </span>
                </a>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 max-w-[420px] text-center font-sans text-[13px] italic text-[#9CA3AF]" data-id="element-199" data-mp="qj276mo74yqu">
          Cada opción abre WhatsApp con un mensaje orientado a tu necesidad específica.
        </p>
      </div>
    </section>;
}